import { Avatar, Flex, Text, Tooltip } from ".."
import { joinBytItems } from "../../../utils"
import DateTime from "../../../utils/dateTime"
import { Separator } from "../../custom"

export const CommentHeader = ({ avatarURL, designation, location, name, dateAndTime }) => {
  return (
    <Flex gap="2px" align="start">
      <Avatar size={34} style={{ marginInlineEnd: 8 }}>
        {name?.[0]}
      </Avatar>
      {joinBytItems([
        <Flex gap="0" vertical>
          <Flex gap="2px" align="center">
            <Text>{name}</Text>
            <Separator />
            <Tooltip title={DateTime.formatDate(dateAndTime, "YYYY-MM-DD HH:mm:ss")}>
              <Text type="secondary" className="fs12">
                {DateTime.fromDateAndTime(dateAndTime)}
              </Text>
            </Tooltip>
          </Flex>
          <Text type="secondary" className="fs12">
            {joinBytItems([designation, location], " - ")}
          </Text>
        </Flex>,
      ])}
    </Flex>
  )
}
